// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"42417f89","563":"21b04445"}[chunkId] + ".chunk.css";
};